// extracted by mini-css-extract-plugin
export default {"meal":"MealItem_meal__5rKu+","description":"MealItem_description__5QJGG","price":"MealItem_price__mXPf2"};